// import { Box, Typography, Stack } from "@mui/material";
// import TripFormCard from "./TripFormCard";

// import Thumb from "../../assets/images/Travel/Thumb.png";
// import AffordPlan from "../../assets/images/Travel/AffordPlan.png";
// import TravelAssurance from "../../assets/images/Travel/TravelAssurance.png";
// import TravelHeroBanner from "../../assets/images/Travel/TravelHeroBanner.jpg";

// export default function HeroSection() {
//   return (
//     <Box
//       sx={{
//         backgroundImage: `url(${TravelHeroBanner})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         minHeight: "400px",
//         display: "flex",
//         flexDirection: { xs: "column-reverse", md: "row" }, // Responsive: column-reverse on small, row on md+
//         alignItems: "center",
//         justifyContent: "space-between",
//         px: { xs: 2, md: 4 },
//         py: { xs: 4, md: 6 },
//         gap: { xs: 4, md: 0 }, // Add gap between card and text on mobile
//       }}
//     >
//       {/* Left Section */}
//       <Box sx={{ color: "#000", textAlign: { xs: "center", md: "left" } }}>
//         <Typography
//           variant="h3"
//           fontSize={{
//             fontWeight: 600,
//             xs: "2rem",
//             md: "1.5rem",
//             fontFamily: '"Poppins", serif',
//           }}
//         >
//           Buy Travel Insurance <br /> Online in 2 Minutes! ⚡
//         </Typography>

//         <Stack spacing={2} mt={4}>
//           <Stack
//             direction="row"
//             spacing={2}
//             alignItems="center"
//             justifyContent={{ xs: "center", md: "flex-start" }}
//           >
//             <img src={AffordPlan} alt="Affordable" width={30} />
//             <Box>
//               <Typography
//                 sx={{ fontFamily: '"Poppins", serif', fontWeight: 600 }}
//               >
//                 Pocket-friendly
//               </Typography>
//               <Typography sx={{ fontFamily: '"Poppins", serif' }}>
//                 Plans starting at a nominal price per day.
//               </Typography>
//             </Box>
//           </Stack>

//           <Stack
//             direction="row"
//             spacing={2}
//             alignItems="center"
//             justifyContent={{ xs: "center", md: "flex-start" }}
//           >
//             <img src={TravelAssurance} alt="Instant Claims" width={30} />
//             <Box>
//               <Typography
//                 sx={{ fontFamily: '"Poppins", serif', fontWeight: 600 }}
//               >
//                 Quick Claims Settlements
//               </Typography>
//               <Typography sx={{ fontFamily: '"Poppins", serif' }}>
//                 Same-day settlement for 9 out of every 10 claims.
//               </Typography>
//             </Box>
//           </Stack>
//           <Stack
//             direction="row"
//             spacing={2}
//             alignItems="center"
//             justifyContent={{ xs: "center", md: "flex-start" }}
//           >
//             <img src={Thumb} alt="Edit" width={30} />
//             <Box>
//               <Typography
//                 sx={{ fontFamily: '"Poppins", serif', fontWeight: 600 }}
//               >
//                 Easy to Manage
//               </Typography>
//               <Typography sx={{ fontFamily: '"Poppins", serif' }}>
//                 Manage and modify your travel plans seamlessly via the app.
//               </Typography>
//             </Box>
//           </Stack>
//         </Stack>
//       </Box>

//       {/* Right Section (Trip Form Card) */}
//       <Box
//         sx={{
//           width: { xs: "100%", md: "auto" },
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         {/* <TripFormCard /> */}
//       </Box>
//     </Box>
//   );
// }
import React from "react";
import { Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "../Gadgets/Banner.css"; // your custom dot styles
import "swiper/css/pagination";

const HeroSection = ({
  bannerList = [],
  height = { xs: "200px", sm: "300px", md: "500px", lg: "650px" },
}) => {
  return (
    <Swiper
      modules={[Autoplay, Pagination]}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop={true}
      pagination={{ clickable: true }}
      style={{ width: "100%" }} // keep width here
    >
      {bannerList?.map((img, index) => (
        <SwiperSlide key={index}>
          <Box
            sx={{
              width: "100%",
              height: height, // now it will work responsively!
              backgroundImage: `url(${img})`,
              backgroundSize: {
                xs: "contain",
                sm: "contain",
                md: "cover",
                lg: "cover",
              },
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default HeroSection;
